import React from 'react';
import { Counter } from './features/counter/Counter';
import './App.css';
import { SessionWatch } from "./features/sessionWatch/SessionWatch";
import { NavBar } from "./features/sessionWatch/features/nav/NavBar";

function App({ setShowSessionTracker, showBreakManager, setShowBreakManager }) {
    return <>
        {/* <NavBar
            setShowSessionTracker={setShowSessionTracker}
            showBreakManager={showBreakManager}
            setShowBreakManager={setShowBreakManager}
        /> */}
        <SessionWatch />
    </>
}

export default App;
